import React from "react";
import axios from "axios";
import Header from "../Components/header";
import Footer from "../Components/footer";

import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useCallback, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;

const stripePromise = loadStripe(STRIPE_API_KEY);

const API_URL = process.env.REACT_APP_API_URL;

const CheckoutForm = () => {
  const [clientSecret, setClientSecret] = useState("");
  const [isLogged, setIsLogged] = useState(true);
  const location = useLocation();
  const data = location.state?.data || {};
  //const { isGift, id_prodotto } = data;

  useEffect(() => {
    const fetchClientSecret = async () => {
      try {
        axios.defaults.withCredentials = true;
        const response = await axios.post(
          `${API_URL}/create-checkout-session`,
          {
            data,
          }
        );
        console.log(response);
        setClientSecret(response.data.clientSecret);
      } catch (error) {
        console.error("Error creating payment intent:", error);
        if (error.response && error.response.status === 401) {
          setIsLogged(false);
        }
      }
    };
    fetchClientSecret();
  }, []);
  const options = { clientSecret };

  if (!isLogged) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export const SubscribeCheckoutForm = () => {
  const [clientSecret, setClientSecret] = useState("");
  const [isLogged, setIsLogged] = useState(true);
  const location = useLocation();
  const data = location.state?.data;
  const rivista = location.state?.rivista;
  const previousLocation = location.state?.from || "/";

  useEffect(() => {
    console.log("Location state: ", location.state);
    console.log("Previous Location PROVA:", previousLocation);
    const fetchClientSecret = async () => {
      console.log("RIVISTA:", rivista);
      try {
        axios.defaults.withCredentials = true;
        console.log(data);
        const response = await axios.post(`${API_URL}/subscribe`, {
          id_prodotto: data.id_rivista,
          selectedOption: data.selectedOption,
          ...(data.coupon && { coupon: data.coupon }), // Se `coupon` esiste, lo aggiunge all'oggetto `data`
        });
        setClientSecret(response.data.clientSecret);
      } catch (error) {
        console.error("Error creating payment intent:", error);
        if (error.response && error.response.status === 401) {
          setIsLogged(false);
        }
      }
    };
    fetchClientSecret();
  }, []);
  const options = { clientSecret };

  if (!isLogged) {
    //return <Navigate to="/login" state={{ from: location }} />;
    console.log("PREVIOUS LOCATION:", previousLocation);
    return <Navigate to="/login" state={{ from: previousLocation }} />;
  }

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export const RinnovoCheckoutForm = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [isLogged, setIsLogged] = useState(true);
  const location = useLocation();
  const data = location.state?.data;

  useEffect(() => {
    const fetchClientSecret = async () => {
      try {
        axios.defaults.withCredentials = true;
        console.log(data);
        const response = await axios.post(`${API_URL}/rinnovo`);

        setClientSecret(response.data.clientSecret);
      } catch (error) {
        console.log("QUI");
        console.error("Error creating payment intent:", error);
        if (error.response && error.response.status === 401) {
          setIsLogged(false);
        }

        if (error.response && error.response.status === 400) {
          setErrorMessage(error.response.data.error);
        }
      }
    };
    fetchClientSecret();
  }, []);

  const options = { clientSecret };

  if (!isLogged) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (errorMessage) {
    return (
      <div>
        <Header />
        <h2 className="mt-10 font-bolder text-3xl">{errorMessage}</h2>
      </div>
    );
  }
  return (
    <div id="checkout">
      <Header />
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export const Return = () => {
  const [status, setStatus] = useState(null);
  const [customerEmail, setCustomerEmail] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [error, setError] = useState(null);

  // Determina il messaggio in base al tipo di acquisto
  const isSubscription = !paymentType === "subscription";

  const title = isSubscription
    ? "Grazie per esserti abbonato!"
    : "Grazie per il tuo acquisto!";
  const description = isSubscription
    ? "Il tuo abbonamento inizia con il prossimo numero in spedizione. Per un anno riceverai una nuova rivista ogni 2 mesi."
    : "Puoi visualizzare i dettagli del tuo ordine o tracciare la spedizione tramite il link fornito nella mail di conferma.";

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get("session_id");

    const fetchSessionStatus = async () => {
      try {
        axios.defaults.withCredentials = true;
        const response = await axios.get(
          `${API_URL}/session-status?session_id=${sessionId}`,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        console.log(response);
        setStatus(response.data.status);
        setCustomerEmail(response.data.customer_email);
        setPaymentType(response.data.mode);
      } catch (error) {
        setError(error);
        console.error("ERRORE:", error.response.data);
      }
    };

    if (sessionId) {
      fetchSessionStatus();
    }
  }, []);

  if (error) {
    return (
      <div>
        <section id="success" style={{ textAlign: "center", padding: "20px" }}>
          <iframe src="https://lottie.host/embed/2fcfd446-ae39-41bb-9c33-d1374e1f2fc8/EzSQDWHH9t.json"></iframe>{" "}
          <h2 className="text-4xl font-bold">Errore</h2>
          <p>
            Si è verificato un errore durante l'elaborazione del pagamento. Per
            favore, riprova più tardi.
          </p>
          <p>
            Se il problema persiste, contatta il nostro team di supporto
            all'indirizzo{" "}
            <a href="mailto:support@example.com">
              abbonamenti@modelliticaint.it
            </a>
            .
          </p>
          <a
            href="/"
            className="bg-blue-500 text-white px-4 py-3 mt-5 rounded inline-block
    hover:bg-blue-600 no-underline transition-colors"
          >
            Torna alla home
          </a>
        </section>
      </div>
    );
  }

  if (status === "open") {
    return <Navigate to="/checkout" />;
  }

  if (status === "complete") {
    return (
      <div className="flex flex-col min-h-screen bg-gray-50">
        <Header />
        <section className="flex flex-col items-center justify-center flex-grow text-center px-6">
          <div className="w-full max-w-2xl p-6 ">
            <DotLottieReact
              src="https://lottie.host/cbecb3e6-6b91-44f8-a116-a0741392f5b9/A8eyO43Xod.json"
              loop
              autoplay
              className="w-48 h-48 mx-auto"
            />
            <h2 className="text-3xl font-bold text-gray-800 mt-4">{title}</h2>
            <p className="text-gray-600 mt-2">
              Il tuo pagamento è stato elaborato con successo. Una email di
              conferma è stata inviata a{" "}
              <strong className="text-blue-600">{customerEmail}</strong>.
            </p>
            <p className="text-gray-600 mt-2">{description}</p>
            <p className="text-gray-600 mt-2">
              Se hai domande o hai bisogno di aiuto, contattaci a{" "}
              <a
                href="mailto:abbonamenti@modellisticaint.it"
                className="text-blue-500 hover:underline"
              >
                abbonamenti@modellisticaint.it
              </a>
              .
            </p>
            <p className="text-gray-700 mt-4 font-medium">
              Grazie per averci scelto, speriamo di rivederti presto! 🚀
            </p>
            <a
              href="/"
              className="bg-blue-500 text-white px-4 py-3 mt-5 rounded inline-block
    hover:bg-blue-600 no-underline transition-colors"
            >
              Torna alla home
            </a>
          </div>
        </section>
        <Footer />
      </div>
    );
  }

  return null;
};

export default CheckoutForm;
